module.exports = __webpack_public_path__ + "static/media/customer_0.c1591c6f.png";